// extracted by mini-css-extract-plugin
export default {"title":"StandardCard_title__b7ysn","icon":"StandardCard_icon__SaGtC","active":"StandardCard_active__1fviR"};